// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s4yX","delete":"styles_delete___WtS1","update":"styles_update__3Pmuu","add":"styles_add__JRQCL"};